
define('inlineSvg!svgs/commercial/icon-clock', function () {return '<span class="inline-icon-clock inline-commercial"><svg width="10.5" height="10.5" viewBox="0 0 10.5 10.5"><path class="st0" d="M5.2 0C2.4 0 0 2.4 0 5.2c0 2.9 2.4 5.3 5.2 5.3s5.2-2.4 5.2-5.3C10.5 2.4 8.1 0 5.2 0m3.4 5.7L5.3 6l-.6-.6L5 1h.5l.3 4.1 2.8.2v.4z"/></svg></span>';});

